"use client";

import { useLanguage } from "@/contexts/LanguageContext";

interface Review {
  name: string;
  nameAr: string;
  text: string;
  textAr: string;
  rating: number;
}

const reviews: Review[] = [
  {
    name: "Sarah Al-Mansouri",
    nameAr: "سارة المنصوري",
    text: "The quality of the extensions is absolutely exceptional. The Scandinavian technique they use is so gentle and the results look completely natural. I've received so many compliments!",
    textAr: "جودة الوصلات استثنائية تمامًا. التقنية الاسكندنافية التي يستخدمونها لطيفة جدًا والنتائج تبدو طبيعية تمامًا. لقد تلقيت الكثير من الإطراءات!",
    rating: 5
  },
  {
    name: "Layla Hassan",
    nameAr: "ليلى حسن",
    text: "I've tried many salons in Dubai, but HÅR Extension is truly luxurious. The European hair quality is unmatched and the service is so professional. Worth every dirham!",
    textAr: "لقد جربت العديد من الصالونات في دبي، لكن HÅR Extension فاخر حقًا. جودة الشعر الأوروبي لا مثيل لها والخدمة احترافية للغاية. يستحق كل درهم!",
    rating: 5
  },
  {
    name: "Fatima Al-Zahra",
    nameAr: "فاطمة الزهراء",
    text: "The attention to detail is incredible. They took time to match my hair perfectly and explained the entire Scandinavian method. My extensions have lasted beautifully for months!",
    textAr: "الاهتمام بالتفاصيل لا يصدق. أخذوا وقتًا لمطابقة شعري بشكل مثالي وشرحوا الطريقة الاسكندنافية بالكامل. استمرت وصلاتي بشكل جميل لأشهر!",
    rating: 5
  },
  {
    name: "Mariam Abdullah",
    nameAr: "مريم عبدالله",
    text: "Such a luxurious experience from start to finish. The salon atmosphere is elegant and calming, and the results exceeded my expectations. The 55cm collection gave me exactly the volume I wanted.",
    textAr: "تجربة فاخرة من البداية إلى النهاية. أجواء الصالون أنيقة ومريحة، والنتائج فاقت توقعاتي. أعطتني مجموعة 55 سم بالضبط الكثافة التي أردتها.",
    rating: 5
  },
  {
    name: "Noor Al-Qasimi",
    nameAr: "نور القاسمي",
    text: "The best investment I've made in my hair! The Remy European hair is so soft and silky. The team is knowledgeable and made me feel so comfortable. Highly recommend!",
    textAr: "أفضل استثمار قمت به في شعري! شعر ريمي الأوروبي ناعم وحريري جدًا. الفريق على دراية وجعلني أشعر بالراحة الشديدة. أوصي به بشدة!",
    rating: 5
  }
];

export default function ReviewsSection() {
  const { language, t } = useLanguage();
  const isArabic = language === 'AR';

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-10 h-px bg-gold" />
            <span className="text-xs font-semibold tracking-luxury text-gold uppercase">
              {isArabic ? 'آراء العملاء' : 'Client Reviews'}
            </span>
            <span className="w-10 h-px bg-gold" />
          </div>
          <h2 className="font-serif text-5xl md:text-6xl font-normal text-charcoal mb-6">
            {isArabic ? 'ما يقوله' : 'What Our'}
            <span className="block italic text-gold mt-2">{isArabic ? 'عملاؤنا' : 'Clients Say'}</span>
          </h2>
          <p className="text-lg text-muted font-light max-w-2xl mx-auto leading-relaxed">
            {isArabic 
              ? 'اكتشف لماذا تثق النساء في دبي بنا لتحقيق تحولات شعر استثنائية' :'Discover why women in Dubai trust us for exceptional hair transformations'}
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-sand/30 rounded-[2rem] p-8 border border-warm hover:shadow-luxury-lg transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <svg
                    key={i}
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="text-gold"
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-charcoal/80 font-light leading-relaxed mb-6 text-base">
                {isArabic ? review.textAr : review.text}
              </p>

              {/* Reviewer Name */}
              <div className="pt-5 border-t border-warm">
                <p className="font-semibold text-charcoal text-sm">
                  {isArabic ? review.nameAr : review.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}